<script>
import {ssoApi} from "@/api/organization";
import {mapMutations} from "vuex";
import {Dialog} from "vant";
export default {
  name: "WechatAuthorize",
  data() {
    return {
      loading: true,
      rules: {
        name: [{required: true, message: "请输入用户名", trigger: "blur"}],
        pwd: [{required: true, message: "请输入密码", trigger: "blur"}]
      },
      form: {
        replace: false,
        name: '',
        pwd: '',
        openId: '',
        unionId: '',
      },
    }
  },
  created() {
    const code = this.$route.query.code;
    ssoApi.wxLogin(code).then(r => {
      this.loading = false;
      if(r.data.result === 0){
        this.updateAndGo(r.data.data);
      }else if(r.data.result === 1){ // 用户未绑定
        this.form.openId = r.data.data.openId;
        this.form.unionId = r.data.data.unionId;
      } else {
        this.error = true;
      }
    }).catch(() => {
      this.loading = false;
      this.error = true;
    });
  },
  methods: {
    ...mapMutations(["changeLogin"]),
    updateAndGo(rd) {
      this.changeLogin(rd);
      this.$router.replace('/list');
    },
    checkForm(){
      this.$refs['form'].validate(valid => {
        if(valid){
            this.onBind(false);
        }
      });
    },
    onBind(replace){
      this.saving = true;
      if (replace === undefined) {
        replace = false;
      }
      this.form.replace = replace;
      ssoApi.wxBind(this.form).then(r => {
        this.saving = false;
        if (r.data.result === 0) {
          this.updateAndGo(r.data.data);
        } else if (r.data.result < -10) {
          Dialog.confirm({
            title: '提示',
            message: '账户已绑定其他微信，是否替换？',
            confirmButtonText: '替换',
            cancelButtonText: '取消',
          }).then(() => {
            this.onBind(true);
          });
        }
      }).catch(() => {
        this.saving = false;
      });
    },
  }
};
</script>

<template>
  <el-container class="loginPage">
    <el-main class="main">
      <div class="titleText">河北省计量业务应用平台</div>
      <div class="title1">微信用户绑定</div>
      <el-form ref="form" class="bindWXform" :rules="rules" :model="form">
        <el-form-item prop="name">
          <el-input placeholder="请输入用户名"
                    prefix-icon="iconfont iconlui-sys-user"
                    @keyup.enter.native="login('form_login')"
                    v-model.trim="form.name">
          </el-input>
        </el-form-item>
        <el-form-item prop="pwd" style="position:relative;">
          <el-input placeholder="请输入密码"
                    prefix-icon="iconfont iconzu"
                    show-password
                    v-model.trim="form.pwd">
          </el-input>
        </el-form-item>
        <div class="btnBox">
          <el-button round type="primary" @click="checkForm" :loading="saving" class="login_btn" v-loading.fullscreen.lock="loading">立即绑定</el-button>
        </div>
      </el-form>
    </el-main>
    <el-footer>
      <span>版权所有：河北省计量检测技术中心</span>
      <span>单位地址：河北省石家庄市友谊南大街175号</span>
      <br>
      <span>冀ICP备20012392号-94</span>
    </el-footer>
  </el-container>
</template>

<style lang="scss">
.loginPage {
  background: url("../../../static/image/login/bgimg.jpg") 50% no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .main{
    text-align: center;
    margin: 5px auto;

    width: 500px;
    position: absolute;
    bottom: 50%;
    margin-bottom: -170px;
    left: 50%;
    margin-left: -250px;
    background-image: url("../../../static/image/login/bg2-img.png");
    background-size: 100% 100%;
    padding: 50px;
    padding-bottom: 70px;
    overflow: unset;

    .el-form-item{
      margin-bottom: 40px;
    }
    .title1{
      margin: 0 auto 30px auto;
      text-align: center;
      font-size: 20px;
      color: #fff;
      font-size: 23px;
      font-weight: 500;
    }
    .el-input__inner{
      border: 1px solid #018ad2;
      background-color: rgba(0,0,0,0) !important;
      color: #d1d6e6;
    }

    .el-input__icon, .el-input__prefix {
      height: 100%;
      text-align: center;
      -webkit-transition: all .3s;
      transition: all .3s;
      left: 8px;
    }
    .el-input__icon {
      width: 25px;
      line-height: 40px;
    }
    .btnBox{
      position: relative;
    }
    .regist-company {
      color: #018ad2;
      position: absolute;
      right: 0;
      top: 55px;
      font-size: 14px;
    }
    .register {
      color: #018ad2;
      position: absolute;
      left: 0;
      top: 55px;
      font-size: 14px;
    }
    .btn{
      width: 100%;
    }
    .nopsw {
      position: absolute;
      bottom: -30px;
      right: 5px;
      color: #018ad2;
      font-size: 15px;
      line-height: 30px;
      cursor: pointer;
    }
  }

  /*标题*/
  .titleText {
    width: 100%;
    text-align: center;
    color: #fff;
    font-size: 34px;
    font-weight: bold;
    position: absolute;
    top: -80px;
    left: 0;
  }

  .el-footer{
    text-align: center;color: #fff;
    position: fixed;
    bottom: 7vh;
    left: 0;
    right: 0;
    font-size: 14px;
    >span{
      margin: 0 20px;
      line-height: 45px;
    }
  }

  @keyframes hzfirst {
    0% {
      background-color: #F40002
    }
    50% {
      background-color: rgba(8,82,173)
    }
    100% {
      background-color: #F40002
    }
  }
  .flashing{
    border: 1px solid transparent;
    /*默认背景颜色*/
    background-color: red;
    /*动画元素名-动画整个过程的时间*/
    animation: hzfirst 2s;
    /*动画次数*/
    animation-iteration-count: 60;
  }
}
</style>